import dynamic from "next/dynamic";

/**
 * Section components that `Content` resolves by name, split one chunk per section.
 *
 * Re-exporting these statically pulled every section — and every content JSON those
 * sections import — into a single chunk that all 144 pages downloaded, even though a
 * given page renders only a handful of them. These stay server-rendered, so the markup
 * is unchanged; only the client chunk each one travels in differs.
 */
export const AwardsSection = dynamic(() => import("./AwardsSection").then((m) => m.AwardsSection));
export const CommitteeSection = dynamic(() => import("./CommitteeSection").then((m) => m.CommitteeSection));
export const EventsSection = dynamic(() => import("./EventsSection").then((m) => m.EventsSection));
export const ExpectationsSection = dynamic(() => import("./ExpectationsSection").then((m) => m.ExpectationsSection));
export const GallerySection = dynamic(() => import("./GallerySection").then((m) => m.GallerySection));
export const HistorySection = dynamic(() => import("./HistorySection").then((m) => m.HistorySection));
export const InsightsSection = dynamic(() => import("./InsightsSection").then((m) => m.InsightsSection));
export const JobSearchWidget = dynamic(() => import("./JobSearchWidget").then((m) => m.JobSearchWidget));
export const LatestJobsSection = dynamic(() => import("./LatestJobsSection").then((m) => m.LatestJobsSection));
export const RecruitmentProcessSection = dynamic(() =>
  import("./RecruitmentProcessSection").then((m) => m.RecruitmentProcessSection)
);
export const SolutionsSection = dynamic(() => import("./SolutionsSection").then((m) => m.SolutionsSection));
export const SpecialismsSection = dynamic(() => import("./SpecialismsSection").then((m) => m.SpecialismsSection));
export const StatisticsSection = dynamic(() => import("./StatisticsSection").then((m) => m.StatisticsSection));
export const ValuesSection = dynamic(() => import("./ValuesSection").then((m) => m.ValuesSection));
